

import UpDownArrows from './UpDownArrows'
const TotalAgentsOnline = ({onlineAgentsCount}) => {
    return (
        <div className="quickStats-block">
            <div>
                <h3>{ onlineAgentsCount }</h3>
                <UpDownArrows />
            </div>
            <h5>Total Agents<br />Online</h5>
        </div>
    )
}

export default TotalAgentsOnline
